import React from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { StageSize } from '../../../../types/canvas.types';
import { Html } from 'react-konva-utils';
import { CanvasButton } from '../common/CanvasButton';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';

interface CanvasPaginationControlsProps {
  stageSize: StageSize;
  numPages: number;
  pageIndex: number;
  setPageIndex: Dispatch<SetStateAction<number>>;
  documentType: string;
}

const CanvasPaginationControls: React.FC<CanvasPaginationControlsProps> = ({
  stageSize,
  numPages,
  pageIndex,
  setPageIndex,
}) => {
  return (
    <Html
      transformFunc={(attrs) => ({
        ...attrs,
        x: stageSize.width - 115,
        y: numPages > 1 ? stageSize.height - 82 : stageSize.height - 40,
      })}
    >
      <div
        className="z-[100] flex flex-col items-center"
        id="canvas-pagination-controls"
      >
        <p
          className="mb-2 text-sm text-neutralText-dark"
          style={{
            textShadow: '0 0px 5px rgba(0, 0, 0, 1)',
          }}
        >
          <span className="font-medium">Page {pageIndex + 1}</span>{' '}
          <span>sur {numPages}</span>
        </p>
        {numPages > 1 && (
          <div className="flex">
            <CanvasButton
              title="nextPrevPage"
              icon={
                <BiChevronLeft className="text-xl text-neutralText dark:text-neutralBG sm:text-2xl" />
              }
              tooltipContent="Précédent"
              tooltipPlace="top"
              onClick={() => setPageIndex((oldIndex: number) => oldIndex - 1)}
              disabled={pageIndex === 0 ? true : false}
              addStyle={`rounded-l-md ${
                pageIndex === 0
                  ? 'cursor-default opacity-60'
                  : 'opacity-100 hover:bg-[#ededed] dark:bg-[#4b494b] dark:hover:bg-[#545454]'
              }`}
            />
            <CanvasButton
              title="nextPrevPage"
              icon={
                <BiChevronRight className="text-xl text-neutralText dark:text-neutralBG sm:text-2xl" />
              }
              tooltipContent="Suivant"
              tooltipPlace="top"
              onClick={() => setPageIndex((oldIndex: number) => oldIndex + 1)}
              disabled={numPages > pageIndex + 1 ? false : true}
              addStyle={`rounded-r-md ${
                numPages > pageIndex + 1
                  ? 'opacity-100 hover:bg-[#ededed] dark:bg-[#4b494b] dark:hover:bg-[#545454]'
                  : 'opacity-60 cursor-default'
              }`}
            />
          </div>
        )}
      </div>
    </Html>
  );
};

export default CanvasPaginationControls;
